import './App.css';
import Navbar from './components/Navbar';
import ProductCase from './components/ProductCase'
import { CarouselDefault } from './components/ProductShowCase';
import { useState, useEffect } from "react";


function App() {
  
  const [ amount, setAmount ] = useState(0)
  const [ cart, setCart ] = useState(0)
  
  const decrement = () =>{

      if (amount !== 0){setAmount(amount-1)}

  }
  const increment = () =>{
    if ( amount < 10 ){setAmount(amount+1)
  }}


  const addToCart = () =>{
    setCart(amount)
  }

  const delCartItem = ()=>{
      setAmount(0)
  }

  useEffect(() => {
    // This effect will run after `amount` has been updated.
    if (amount === 0) {
      addToCart(0);
    }
  }, [amount]); // Dependency array

  return (
    <div className='w-full lg:mx-auto lg:max-w-7xl'>
    <Navbar cart={cart} callDelCartItem={delCartItem}/>
    <div className="flex mx-auto flex-col lg:flex-row lg:items-center lg:gap-10 lg:mt-40 lg:px-5">
      <CarouselDefault/>
      <ProductCase 
        callAddtoCart={addToCart}
        callDecrement={decrement}
        callInrement={increment}
        getAmount={amount}
        />
    </div>

  </div>
  )
}

export default App;
